import { FC } from 'react';
import { LineItem } from 'shared/types/cart';
import Typography from 'components/commercetools-ui/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useI18n from 'helpers/hooks/useI18n';

interface ItemPriceProps {
  item: LineItem;
  layout?: 'horizontal' | 'vertical';
}

const ItemPrice: FC<ItemPriceProps> = ({ item, layout = 'horizontal' }) => {
  const { locale } = useI18n();

  if (item.isGift) {
    return (
      <Typography translation={{ id: 'gift', file: 'cart' }} className="text-14 font-normal">
        Gift
      </Typography>
    );
  }

  if (item.discountedPrice) {
    if (layout === 'vertical') {
      return (
        <div className="flex flex-col items-end gap-1">
          <Typography className="body-text font-bold leading-6 text-primary">
            {CurrencyHelpers.formatForCurrency(item.discountedPrice, locale)}
          </Typography>
          <Typography className="body-text font-normal leading-loose text-tertiary line-through">
            {CurrencyHelpers.formatForCurrency(item.price ?? 0, locale)}
          </Typography>
        </div>
      );
    } else {
      return (
        <div className="flex items-center gap-5">
          <Typography className="body-text font-bold leading-6 text-primary">
            {CurrencyHelpers.formatForCurrency(item.discountedPrice, locale)}
          </Typography>
          <Typography className="body-text font-normal leading-loose text-tertiary line-through">
            {CurrencyHelpers.formatForCurrency(item.price ?? 0, locale)}
          </Typography>
        </div>
      );
    }
  }

  return (
    <Typography className="body-text font-bold leading-6">
      {CurrencyHelpers.formatForCurrency(item.price ?? 0, locale)}
    </Typography>
  );
};

export default ItemPrice;
